const refs = 'home'
export default [
    {
        path: '/',
        redirect: "/home"
    },
    {
        path: '/home',
        name: refs, 
        component: () => import('@/views/'+refs+'/List.vue')
    }
]